<template>
  <div id="fields-table-view" class="doc-univ">
    <div v-if="tableLoadStatus === 'idle' || tableLoadStatus === 'loading'" id="scrollarea" class="table-view"></div>

    <div v-else id="scrollarea" class="table-view">
      <b-row id="tableview-head-row" class="table-view_headrow">
        <b-col class="table-view_headrow_col wide col-4 d-flex">
          <p class="m-0">Field Name</p>
          <!-- <b-btn variant="outline-secondary" class="p-0 ml-auto btn-image" @click="saveFieldNames()"> <img src="/images/sparks.png" alt="Mynd - Ai"> Auto Generate</b-btn> -->
          <div class="ml-auto table-view__actions">
          <b-btn variant="outline-secondary" size="sm" class="table-view__generate-btn" @click="saveFieldNames()">
            <span class="table-view__generate-content">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-openai table-view__generate-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path d="M14.949 6.547a3.94 3.94 0 0 0-.348-3.273 4.11 4.11 0 0 0-4.4-1.934A4.1 4.1 0 0 0 8.423.2 4.15 4.15 0 0 0 6.305.086a4.1 4.1 0 0 0-1.891.948 4.04 4.04 0 0 0-1.158 1.753 4.1 4.1 0 0 0-1.563.679A4 4 0 0 0 .554 4.72a3.99 3.99 0 0 0 .502 4.731 3.94 3.94 0 0 0 .346 3.274 4.11 4.11 0 0 0 4.402 1.933c.382.425.852.764 1.377.995.526.231 1.095.35 1.67.346 1.78.002 3.358-1.132 3.901-2.804a4.1 4.1 0 0 0 1.563-.68 4 4 0 0 0 1.14-1.253 3.99 3.99 0 0 0-.506-4.716m-6.097 8.406a3.05 3.05 0 0 1-1.945-.694l.096-.054 3.23-1.838a.53.53 0 0 0 .265-.455v-4.49l1.366.778q.02.011.025.035v3.722c-.003 1.653-1.361 2.992-3.037 2.996m-6.53-2.75a2.95 2.95 0 0 1-.36-2.01l.095.057L5.29 12.09a.53.53 0 0 0 .527 0l3.949-2.246v1.555a.05.05 0 0 1-.022.041L6.473 13.3c-1.454.826-3.311.335-4.15-1.098m-.85-6.94A3.02 3.02 0 0 1 3.07 3.949v3.785a.51.51 0 0 0 .262.451l3.93 2.237-1.366.779a.05.05 0 0 1-.048 0L2.585 9.342a2.98 2.98 0 0 1-1.113-4.094zm11.216 2.571L8.747 5.576l1.362-.776a.05.05 0 0 1 .048 0l3.265 1.86a3 3 0 0 1 1.173 1.207 2.96 2.96 0 0 1-.27 3.2 3.05 3.05 0 0 1-1.36.997V8.279a.52.52 0 0 0-.276-.445m1.36-2.015-.097-.057-3.226-1.855a.53.53 0 0 0-.53 0L6.249 6.153V4.598a.04.04 0 0 1 .019-.04L9.533 2.7a3.07 3.07 0 0 1 3.257.139c.474.325.843.778 1.066 1.303.223.526.289 1.103.191 1.664zM5.503 8.575 4.139 7.8a.05.05 0 0 1-.026-.037V4.049c0-.57.166-1.127.476-1.607s.752-.864 1.275-1.105a3.08 3.08 0 0 1 3.234.41l-.096.054-3.23 1.838a.53.53 0 0 0-.265.455zm.742-1.577 1.758-1 1.762 1v2l-1.755 1-1.762-1z"/>
              </svg>
              <span>Generate Names</span>
            </span>
          </b-btn>
          <b-btn variant="outline-secondary" size="sm" @click="exportFieldTable()"> <i class="fa fa-download" /> Export </b-btn>
          </div>
        </b-col>
        <b-col
          class="
            table-view_headrow_col
            d-flex
            flex-column
            justify-content-center
            align-items-center
          "
        >
          <p class="m-0">Metrics</p>
          <div>
            <b-btn variant="outline" class="p-0 mx-2" @click="sortBy('size')"
              ><i
                class="fa"
                :class="{
                  'fa-sort': sorting.sorter !== 'size',
                  'fa-sort-down': sorting.sizeDir === 'down',
                  'fa-sort-up':
                    sorting.sizeDir === 'up' && sorting.sorter === 'size',
                }"
              ></i>
              Size</b-btn
            >
            <b-btn variant="outline" class="p-0 mx-2" @click="sortBy('recency')"
              ><i
                class="fa"
                :class="{
                  'fa-sort': sorting.sorter !== 'recency',
                  'fa-sort-down': sorting.recencyDir === 'down',
                  'fa-sort-up':
                    sorting.recencyDir === 'up' && sorting.sorter === 'recency',
                }"
              ></i>
              Recency</b-btn
            >
            <b-btn variant="outline" class="p-0 mx-2" @click="sortReset()"
              ><i class="fa fa-eraser"></i> Reset</b-btn
            >
          </div>
        </b-col>
        <b-col class="table-view_headrow_col mw-350">
          <b-row>
            <b-col cols="10" class="pl-0"
              ><ExploreAnalysisCreateAxis
                :axis="rings"
                :multiple="false"
                :size="'compact'"
                :selectLimit=1
              ></ExploreAnalysisCreateAxis
            ></b-col>
            <b-col cols="2" class="d-flex pl-0"
              ><b-btn
                variant="secondary"
                class="align-self-center ml-1"
                @click="viewRings()"
                ><i class="fa fa-arrow-right"></i></b-btn
            ></b-col>
          </b-row>
        </b-col>
        <b-col class="table-view_headrow_col">User Notes</b-col>
        <b-col cols="1" class="table-view_headrow_col text-center"
          >Bookmarks</b-col
        >
      </b-row>

      <TableViewRow
        v-for="field in fields"
        :key="field._id"
        :field="field"
        :raw-data="rawData"
      ></TableViewRow>
    </div>

    <div class="bookmarks">
      <div
        v-for="(name, bm) in fieldBookmarks"
        :key="bm"
        class="bookmark"
        :style="{ top: getBookmarkPosition(bm) + 'px' }"
        @click="goToBookmark(bm)"
      ></div>
    </div>

  </div>
</template>
<script>
import _ from "lodash";
import XLSX from "xlsx";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import AnalysisHelpers from "@/components/Explore/ExploreAnalysis/AnalysisHelpers";
import { EventBus } from "@/eventBus";
import AddBookmarkModal from "../Shared/AddBookmarkModal";
import ExploreAnalysisCreateAxis from "../Shared/ExploreAnalysisCreateAxis";
import TableViewRow from "./TableViewRow";
export default {
  name: "TableView",
  components: {
    AddBookmarkModal,
    ExploreAnalysisCreateAxis,
    TableViewRow
  },
  data() {
    return {
      rawData: [],
      fields: [],
      themes: [],
      players: [],
      comments: null,
      showFields: true,
      showArrows: true,
      showThemes: true,
      showRings: false,
      showRingsNoMatch: false,
      commentModalText: null,
      sorting: {
        sorter: null,
        sizeDir: "up",
        recencyDir: "up",
      },
      rings: {},
      tableLoadStatus: "idle"
    };
  },
  computed: {
    ...mapGetters(["crainDataTable", "fieldBookmarks", "fieldComments" ,"ttcLookup","modelTopic"]),
    ...mapState({
      apiId: (state) => state.api.apiId,
      filterFocused: (state) => state.filter.filterFocused,
      playerQuery: (state) => state.visualization.playerQuery,
      ttc: (state) => state.ttc.ttc,
      visData: (state) => state.visualization.visData,
      dataSettings: state => state.setting.dataSettings
    }),
  },
  watch: {
    tableLoadStatus(val) {
      if (val === "idle" || val === "loading") {
        setTimeout(() => {
          this.loadAnimStart();
          this.initRings();
          this.initTable();
        }, 500);
      }
    },
    filterFocused() {
      EventBus.$emit("resetData");
    },
    visData() {
      this.tableLoadStatus = "loading";
    },
  },
  mounted() {
    EventBus.$on("showFieldsChanged", (value) => {
      this.showFields = value;
    });
    EventBus.$on("showArrowsChanged", (value) => {
      this.showArrows = value;
    });
    EventBus.$on("showThemesChanged", (value) => {
      this.showThemes = value;
    });
    EventBus.$on("showRingsChanged", (value) => {
      this.showRings = value;
    });
    EventBus.$on("showRingsNoMatchChanged", (value) => {
      this.showRingsNoMatch = value;
    });
  },
  async created() {
    this.saveLoadingStep("Loading fields table...");
    this.loadAnimStart();
    this.tableLoadStatus = "loading";
  },
  methods: {
    ...mapActions([
      "changeFieldNamesAi",
      "fieldNamesAiStatus",
      "saveFieldComment",
      "savePlayerQuery",
      "loadAnimStart",
      "loadAnimEnd",
      "saveLoadingStep",
      "loadTTC"
    ]),
    initRings() {
      this.rings = [];
      if (this.playerQuery !== null) {
        this.rings = this.playerQuery;
      } else {
        this.rings = {
          levels: [
            {
              id: 1,
              modifiers: [],
              grouped: false,
              includeAll: true,
              linked: false,
              layers: [],
            },
          ],
        };
      }
    },
    async initTable() {
    // Debug logs to trace problematic areas
    //console.log('initTable: starting', { visData: this.visData });
    let crainData = this.visData.crainDataMap;
    let crainDataThemes = this.visData.crainDataThemes;
    let crainDataTable = this.visData.crainDataTable;
    this.comments = this.dataSettings.fields.fieldComments;
    //console.log('initTable: crainData keys', { hasCrainData: !!crainData, hasThemes: !!crainDataThemes, hasTable: !!crainDataTable });
    this.themes = crainDataThemes.xLayers.map((t) => (t = t[0]));
    //console.log('initTable: themes length', this.themes.length, 'sample theme', this.themes[0]);
        // If filter is used
    let subset = !!(crainData && crainData.subsetLayers && crainData.subsetLayers[0]);
    //console.log('initTable: subset active?', subset);
        this.fields = crainData.xLayers.map((a, fc) => {
          let totalThemeSum = _.sumBy(a[0].themes, function (t) {
            return t[1];
          });
          // Generate index => Fields with all data, can be retrieved on position X: fc, position Y: 0 (All data)
          let ix = fc + "_0_0_0";
          let dataset = _.get(crainData, 'rawData.data[0]');
          if (!dataset) {
            //console.error('initTable: missing dataset for index', ix, { crainData });
          }
          //console.log(`initTable: processing field index ${fc}, ix=${ix}`, { dataExists: !!dataset });
          // Switch between filtered data and regular data if filtdata is available (due to activefilter)
          let data = subset ? dataset[ix].filtdata : dataset[ix].data;

          a = {
            _id: a[0]._id,
            type: a[0].type,
            name: a[0].name,
            themes: _.reverse(
              _.sortBy(a[0].themes, [
                function (s) {
                  return s[1];
                },
              ])
            )
              .slice(0, 5)
              .map((t) => {
                const theme = this.ttcLookup({ id: t[0] });
                t = {
                  _id: t[0],
                  type: theme.type,
                  name: theme.name,
                  percentage: ((t[1] / totalThemeSum) * 100).toFixed(2),
                  concepts: theme.children,
                };
                return t;
              }),
            size: data.size,
            recency: data.recency,
            spread: a[0].spread,
          };
          return a;
        });
        //console.log('initTable: fields built count', this.fields.length, 'sample field', this.fields[0]);
        this.fields = _.sortBy(this.fields, ["_id"]);
        /*if (crainDataTable) {
          this.players = this.crainDataTable.yLayers.map(r => (r = r[0]));
          this.players.splice(0, 1);
          this.players = this.players.map(
            i =>
              (i = {
                _id: i._id,
                type: i.type,
                name: i.name,
                info: "Indice"
              })
          );
        } else {
          this.players = [];
        }*/
        if (crainDataTable) {
          this.fields = this.fields.map((f) => ({
            ...f,
            players: this.getTopPlayers(f._id),
          }));
        } else {
          this.fields = this.fields.map((f) => ({ ...f, players: [] }));
        }
        this.loadAnimEnd();
        this.saveLoadingStep("");
        this.tableLoadStatus = "loaded";
        this.tableRowUpdating = false;
    },

    async exportFieldTable(){
      let fName = "mynd-output-"+moment().unix()+".xlsx";
      let elements = [];
      const customHeader = [["Field", "Size", "Recency", "T1","T2","T3","T4","T5",'P1','P2','P3','P4','P5','User Comments']];
      for (let i = 0; i <this.fields.length; i++){
        let field = this.fields[i];
        elements.push({"Field" : field.name, "Size": field.size, "Recency": field.recency,"T1":field.themes[0] ? field.themes[0].name : "" , "T2": field.themes[1] ? field.themes[1].name : "", "T3": field.themes[2] ? field.themes[2].name : "", "T4": field.themes[3] ? field.themes[3].name : "", "T5": field.themes[4] ? field.themes[4].name : "", 'P1': field.themes[0] ? field.themes[0].percentage: "", 'P2': field.themes[1] ? field.themes[1].percentage: "", 'P3': field.themes[2] ? field.themes[2].percentage: "", 'P4': field.themes[3] ? field.themes[3].percentage: "",
        "P5": field.themes[4] ? field.themes[4].percentage: "",'User Comments': this.comments[field._id] ? this.comments[field._id] : "N/A"});
      }
      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, customHeader);
      XLSX.utils.sheet_add_json(ws, elements, {origin: "A2", skipHeader: true});
      XLSX.utils.book_append_sheet(wb, ws,"Fields Table Data");
      XLSX.writeFile(wb, fName);
    },
    saveFieldNames() {
      // Check if modelTopic exists or is not empty
      if (!this.modelTopic || !this.modelTopic.trim()) {
        // Show alert to set the topic
        this.$bvToast.toast("Please set a topic to continue.", {
          title: "Topic Required",
          variant: "warning",
          solid: true,
          // custom class to shift this toast lower (100px)
          toastClass: 'lower-top-100'
        });
        return;
      }
      this.saveFieldNamesWithTopic(this.modelTopic);
    },

    saveFieldNamesWithTopic(topic) {
      this.saveLoadingStep("Updating field names...");
      this.loadAnimStart();
      this.changeFieldNamesAi({
        topic: topic,
        fields: this.fields.map((f) => ({
          id: f._id,
          titles: this.getTitles(f),
        })),
      })
        .then(() => {
          this.initiateNamingProcessStatusCheck();
        })
        .catch(() => {
          this.loadAnimEnd();
          this.saveLoadingStep("");
          this.$bvToast.toast(
            "Field naming process failed. Please try again.",
            {
              title: "Field Naming",
              variant: "danger",
              solid: true,
            }
          );
        });
    },
    getTitles(field) {
      let titles = [];
      for (let i = 0; i < field.themes.length; i++) {
        if (field.themes[i].percentage >= 20) {
          titles = [...titles, ...field.themes[i].name.split(',')];
        }
      }
      return titles;
    },
    async initiateNamingProcessStatusCheck() {
      let checkInterval = setInterval(async () => {
        const res = await this.fieldNamesAiStatus(this.apiId);
        if (res.status === "Completed") {
          clearInterval(checkInterval);
          //reload page here
          location.reload();
          //EventBus.$emit("resetData");
          /*
          this.tableRowUpdating = true;
          this.loadTTC().then(() => {
            setTimeout(() => {
              this.initTable();
            }, 20000);
          }).catch(() => {
            this.loadAnimEnd();
            this.saveLoadingStep("");
          });
          */

        }
      }, 10000); // Check every 10 seconds
    },
    getTopPlayers(field) {
      const crainData = this.crainDataTable;
      const fid = _.findIndex(crainData.xLayers, function (f) {
        return f[0]._id === field;
      });
      const pKeys = Object.keys(crainData.rawData.data[0]);
      const group = _.filter(pKeys, function (p) {
        return p.split("_")[0] === `${fid}`;
      });
      let procPlayers = this.processPlayers(group);
      let plen = procPlayers[0].length;
      let players = _.orderBy(procPlayers[0], ["size"], ["desc"]).slice(0, 5);
      return { list: players, total: procPlayers[1], length: plen };
    },
    processPlayers(group) {
      const crainData = this.crainDataTable;
      let players = [];
      let sum = 0;
      _.each(group, function (k) {
        let pl = parseInt(k.split("_")[1]);
        if (pl > 0) {
          players.push({
            name: crainData.yLayers[pl][0].name,
            size: _.get(crainData.rawData.data[0], k).data.size,
            _id: crainData.yLayers[pl][0]._id,
          });
          sum += _.get(crainData.rawData.data[0], k).data.size;
        }
      });
      return [players, sum];
    },
    viewRings() {
      this.savePlayerQuery(this.rings);
      EventBus.$emit("setTableTop", this.buildQueryLayers(this.rings));
    },
    buildQueryLayers(axis) {
      const preselect = { top: 5, overlap: false };
      const preselectWhenModifiersEmpty = { top: 150 };
      return AnalysisHelpers.buildQueryLayers(
        axis,
        preselect,
        preselectWhenModifiersEmpty
      );
    },
    goToBookmark(field) {
      let index = _.findIndex(this.fields, function (o) {
        return o._id === field;
      });
      let offSet =
        document.getElementsByClassName("table-view_row_col")[0].offsetHeight;
      document.getElementById("scrollarea").scrollTop = offSet * index;
    },
    getBookmarkPosition(field) {
      if (!document.getElementById("fields-table-view")) {
        return;
      }
      const index = _.findIndex(this.fields, (o) => o._id === field);
      const tl = document.getElementById("fields-table-view").offsetHeight - 6;
      const pt = tl / this.fields.length;
      return Math.round(index * pt);
    },
    showOptions(item) {
      EventBus.$emit("showOptions", item);
    },
    sortBy(sorter) {
      this.sorting.sorter = sorter;
      if (this.sorting.sorter === "size") {
        this.sorting.recencyDir = "up";
        if (this.sorting.sizeDir === "up") {
          this.fields = _.sortBy(this.fields, ["size"]);
          this.sorting.sizeDir = "down";
        } else {
          this.sorting.sizeDir = "up";
          _.reverse(this.fields);
        }
      } else {
        this.sorting.sizeDir = "up";
        if (this.sorting.recencyDir === "up") {
          this.fields = _.sortBy(this.fields, ["recency"]);
          this.sorting.recencyDir = "down";
        } else {
          this.sorting.recencyDir = "up";
          _.reverse(this.fields);
        }
      }
    },
    sortReset() {
      this.fields = _.sortBy(this.fields, ["_id"]);
      this.sorting = {
        sorter: null,
        sizeDir: "up",
        recencyDir: "up",
      };
    },
  }
};
</script>

<style scoped>
.table-view__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.table-view__generate-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  line-height: inherit;
  white-space: nowrap;
}

.table-view__generate-icon {
  display: inline-block;
  flex: 0 0 auto;
  width: 1em;
  height: 1em;
  vertical-align: middle;
}
</style>

